import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const StatusBarContent = () => {
  const [time, setTime] = useState(new Date());
  const [scrollPct, setScrollPct] = useState(0);
  const [section, setSection] = useState("home");

  useEffect(() => {
    const tick = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(tick);
  }, []);

  useEffect(() => {
    const handle = () => {
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      setScrollPct(docH > 0 ? Math.round((window.scrollY / docH) * 100) : 0);

      const hash = window.location.hash.replace("#", "");
      if (hash) setSection(hash);
    };
    window.addEventListener("scroll", handle, { passive: true });
    handle();
    return () => window.removeEventListener("scroll", handle);
  }, []);

  const hh = time.getHours().toString().padStart(2, "0");
  const mm = time.getMinutes().toString().padStart(2, "0");
  const ss = time.getSeconds().toString().padStart(2, "0");

  return (
    <div className="status-bar">
      <div className="status-bar-left">
        <span className="status-item">
          <span className="status-dot" />
          <span className="status-branch">main</span>
        </span>
        <span className="status-item status-user">vivek@portfolio</span>
        <span className="status-item status-section">
          <i className="fa fa-map-marker" style={{ fontSize: 9, marginRight: 4, opacity: 0.6 }} />
          {section}
        </span>
      </div>
      <div className="status-bar-right">
        <span className="status-item">↕ {scrollPct}%</span>
        <span className="status-item">{hh}:{mm}:{ss}</span>
        <span className="status-mode">v.2.0</span>
      </div>
    </div>
  );
};

const StatusBar = () => {
  return createPortal(<StatusBarContent />, document.body);
};

export default StatusBar;
